module.exports = __webpack_public_path__ + "static/media/Whissh_ECO_Friendly_Cleaning_Product2.5c07cae4.webp";